module.exports = __webpack_public_path__ + "static/img/033幼儿园系统使用手册.f7cdd7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/033幼儿园系统使用手册.jpg
// module id = ySLZ
// module chunks = 0